import '@/styles/normalize.css';
import '@/styles/index.less';
import '@/styles/chartist.min.css';

import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import Chartist from 'vue-chartist';
import VueScrollTo from 'vue-scrollto';
import vMediaQuery from 'v-media-query';
import VueYoutube from 'vue-youtube';
import AOS from 'aos';
import axios from 'axios';
import 'aos/dist/aos.css';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(Chartist);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
Vue.use(vMediaQuery, {
  methods: {
    isDesktop() {
      return vMediaQuery.methods.above('768px');
    },
  },
});
Vue.use(VueYoutube);

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

const r = router(store, Vue.prototype.$http);
sync(store, r);

new Vue({
  created() {
    AOS.init();
  },
  router: r,
  store,
  render: h => h(App),
}).$mount('#app');
